// ═════════════════════════════════════════════════════════════════════════════
//  EL MINIJUEGO QUE TE PONE EL COACH
//
//  Rob pregunto si el coach debe ENLAZAR a los minijuegos o CREARLOS ahi mismo.
//  Ni lo uno ni lo otro:
//
//    · Crearlos con IA se pagaria en cada partida, y un juego improvisado por
//      un modelo es un cuestionario en una caja. Los once que hay tienen
//      diseno, animacion, sonido y contenido revisado.
//    · Enlazar a secas saca al alumno de la conversacion y el coach le pierde.
//
//  Lo que si: el coach ELIGE cual le toca segun lo que falla —eso es lo que el
//  menu de juegos no puede hacer— y se abre ENCIMA del chat. Al salir, el coach
//  sigue ahi. Es el camino que ya demostro FLUENCY NEXUS.
//
//  ── LOS JUEGOS NO SE TOCAN ──────────────────────────────────────────────────
//  Se montan tal cual, sin props ni adaptaciones: son componentes cerrados que
//  ya funcionan en `/multigames`. Este fichero solo decide CUAL se monta y le
//  pone un marco encima del chat.
// ═════════════════════════════════════════════════════════════════════════════

import { useEffect } from "react";
import { X } from "lucide-react";

import VerbDash from "../minigames/VerbDash";
import PiensaRapido from "../minigames/PiensaRapido";
import TraduceOracion from "../minigames/TraduceOracion";
import Basta from "../minigames/Basta";
import NounsInvasion from "../minigames/NounsInvasion";
import AdjectiveLadder from "../minigames/AdjectiveLadder";
import MeaningMatch from "../minigames/MeaningMatch";
import TimeTraveler from "../minigames/TimeTraveler";
import WhereIsIt from "../minigames/WhereIsIt";
import Describing from "../minigames/Describing";
import StudentGame from "../minigames/StudentGame";

import "./CoachJuego.css";

// ⚠️  GEMELO de `MultigamesPage.jsx` · gamesMap y de
//     `backend-api/src/coach/asistentes.py` · JUEGOS. Las claves tienen que ser
//     las mismas en los tres o el coach ofrecera un juego que no se abre.
const JUEGOS = {
  neura_cinema: StudentGame,
  verb_dash: VerbDash,
  piensa_rapido: PiensaRapido,
  traduce_oracion: TraduceOracion,
  basta: Basta,
  plural_invasion: NounsInvasion,
  adjective_ladder: AdjectiveLadder,
  meaning_match: MeaningMatch,
  time_traveler: TimeTraveler,
  where_is_it: WhereIsIt,
  caricaturas: Describing,
};

export function existeJuego(clave) {
  return Boolean(JUEGOS[clave]);
}

export default function CoachJuego({ juego, nombre, icono, color, onCerrar }) {
  const Componente = JUEGOS[juego];

  // Con Escape se sale, como en cualquier cosa que se abre encima. Y mientras
  // esta abierto la pagina de detras no se mueve: si no, al cerrar el juego el
  // alumno aparece en otro punto de la conversacion.
  useEffect(() => {
    const salir = ev => { if (ev.key === "Escape") onCerrar(); };
    document.addEventListener("keydown", salir);
    const antes = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", salir);
      document.body.style.overflow = antes;
    };
  }, [onCerrar]);

  if (!Componente) return null;

  return (
    <div className="cjg-fondo" role="dialog" aria-label={nombre}>
      <div className="cjg-marco" style={{ "--juego-color": color || "#ffff00" }}>
        <header className="cjg-cabecera">
          <span className="cjg-icono" aria-hidden="true">{icono}</span>
          <span className="cjg-nombre">{nombre}</span>
          {/* El nombre del coach, para que se note que esto te lo puso EL y no
              es que hayas navegado a otro sitio. */}
          <span className="cjg-firma">Spacy Coach</span>
          <button className="cjg-cerrar" onClick={onCerrar} aria-label="Cerrar el juego">
            <X size={18} />
          </button>
        </header>

        <div className="cjg-lienzo">
          <Componente />
        </div>
      </div>
    </div>
  );
}
